/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

/**
 * Enter here the user flows and custom policies for your B2C application
 * To learn more about user flows, visit: https://docs.microsoft.com/en-us/azure/active-directory-b2c/user-flow-overview
 * To learn more about custom policies, visit: https://docs.microsoft.com/en-us/azure/active-directory-b2c/custom-policy-overview
 */
import Axios from 'axios';
import _ from 'lodash';

let loginPolicy = 'B2C_1A_XOMEPRO_SIGNIN';
let environment = '';

async function loadEnvConfig() {
  try {
    const response = await Axios.get('/env_config/config.json');
    const configData = _.get(response, 'data', null);
    if (!configData) {
      console.warn("Config file loaded but data is null or malformed");
      return;
    }
    environment = _.get(configData, 'environment', '');
    if (environment !== 'prod') {
      loginPolicy = 'B2C_1A_XOMEPRO_SIGNIN_NONPROD';
    }
  } catch (error) {
    console.error("Failed to load config.json", error.message);
  }
}

await loadEnvConfig();

export const b2cPolicies = {
  names: {
    signUpSignIn: loginPolicy,
    forgotPassword: 'B2C_1_XomePro_ResetPassword'
  },
  authorities: {
    signUpSignIn: {
      authority: `https://xomeb2c.b2clogin.com/xomeb2c.onmicrosoft.com/${loginPolicy}`
    },
    forgotPassword: {
      authority: 'https://xomeb2c.b2clogin.com/xomeb2c.onmicrosoft.com/B2C_1_XomePro_ResetPassword'
    }
  },
  authorityDomain: 'xomeb2c.b2clogin.com'
};

/**
 * Configuration object to be passed to MSAL instance on creation.
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md
 */
export const msalConfig = {
  auth: {
    clientId: '84165510-1147-42d4-9fa4-0f7ce67ec9e0', // This is the ONLY mandatory field that you need to supply.
    authority: b2cPolicies.authorities.signUpSignIn.authority, // Choose SUSI as your default authority.
    knownAuthorities: [b2cPolicies.authorityDomain], // Mark your B2C tenant's domain as trusted.
    redirectUri: '/azureb2c', // You must register this URI on Azure Portal/App Registration. Defaults to window.location.origin
    postLogoutRedirectUri: '/', // Indicates the page to navigate after logout.
    navigateToLoginRequestUrl: false // If "true", will navigate back to the original request location before processing the auth code response.
  },
  cache: {
    cacheLocation: 'sessionStorage', // Configures cache location. "sessionStorage" is more secure, but "localStorage" gives you SSO between tabs.
    storeAuthStateInCookie: false // Set this to "true" if you are having issues on IE11 or Edge
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        console.info(message);
      }
    }
  }
};

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit:
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequest = {
  scopes: []
};

/**
 * An optional silentRequest object can be used to achieve silent SSO
 * between applications by providing a "login_hint" property.
 */
export const silentRequest = {
  scopes: ['openid', 'profile']
};
